module.exports = __webpack_public_path__ + "img/dropIcon.4e7f458b.png";